export default __webpack_public_path__ + "static/media/GDPR.04a3bfdc.png";